<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Ville</h2>
    </div>
  </div>
  <CriteresRechercheVilles @rechercher="rechercher"/>
  <ResultatRechercheVilles :villes="villes" :isRechercheDataLoading="isRechercheDataLoading" @removeVilleFromList="removeVilleFromList"/>
</template>

<script>
import CriteresRechercheVilles
  from '../../../../components/pilotage/ClassementDesVilles/Ville/CriteresRechercheVilles.vue'
import ResultatRechercheVilles
  from '../../../../components/pilotage/ClassementDesVilles/Ville/ResultatRechercheVilles.vue'

import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  components: {
    CriteresRechercheVilles,
    ResultatRechercheVilles
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      villes: [],
      isRechercheDataLoading: false
    }
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Ville");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
  },
  methods: {
    rechercher(libelleRecherche) {
      this.villes = [];
      this.isRechercheDataLoading = true;

      this.$store.dispatch("pilotage/rechercherTableValeurAvecAscAction", libelleRecherche).then((res) => {
        this.isRechercheDataLoading = false;
        res.data.libelles.forEach((currentPays) => {
          currentPays.tableValeur.libelles.forEach((currentProvince) => {
            currentProvince.tableValeur.libelles.forEach((currentVille) => {
              let currentVilleComplete = currentVille;
              currentVilleComplete.clePays = currentPays.tableValeur.cle;
              currentVilleComplete.pays = currentPays.tableValeur.description;
              currentVilleComplete.cleProvince = currentProvince.tableValeur.cle;
              currentVilleComplete.province = currentProvince.tableValeur.description;
              this.villes.push(currentVilleComplete)
            })
          })
        })
      });
    },
    removeVilleFromList(ville) {
      this.villes = this.villes.filter(current => (current.cle != ville.cle))
    }
  }
}
</script>
